import Apollo from '@adoratorio/apollo';
import raf from './raf';

const cursor = {
  ref: null,

  init(DOMEelement, callback) {
    this.ref = new Apollo({
      cursor: DOMEelement,
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 600,
      },
      aion: raf,
      callbacks: {
        render: callback,
      },
    });
  },
};

export default cursor;
